if (
  !process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ACCOUNT_ID ||
  !process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_4_ACCOUNT_ID ||
  !process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_SPONSORED_ACCOUNT_ID ||
  !process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_4_SPONSORED_ACCOUNT_ID
) {
  throw new Error("Missing environment variables");
}

interface GoogleAnalyticsIds {
  "GA4 Primary ID": string;
}

export const GA_ACCOUNT_ID =
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ACCOUNT_ID;

export const GA_4_ACCOUNT_ID =
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_4_ACCOUNT_ID;

export const GA_SPONSORED_ACCOUNT_ID =
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_SPONSORED_ACCOUNT_ID;

export const GA_4_SPONSORED_ACCOUNT_ID =
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_4_SPONSORED_ACCOUNT_ID;

export const googleAnalyticsAccountIds: GoogleAnalyticsIds = {
  "GA4 Primary ID": GA_4_ACCOUNT_ID,
};

export const googleAnalyticsSponsoredAccountIds: GoogleAnalyticsIds = {
  "GA4 Primary ID": GA_4_SPONSORED_ACCOUNT_ID,
};
